import { cn } from '../../utils/cn';

export function SelectionCountBadge({ count, className }) {
  return (
    <span
      className={cn(
        'inline-flex h-[25px] shrink-0 items-center gap-1.5 rounded-[13px] px-3 text-xs font-bold',
        count > 0 ? 'bg-sage-600 text-white' : 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {count}
    </span>
  );
}
